<template>
  <div>
    <div v-if="whichOne === 'home'">
      <a-page-header style="width: 105%; margin-left: -20px" title="">
        <template slot="tags">
          <a-breadcrumb>
            <a-breadcrumb-item href="">
              <a-icon type="rocket" />
              <span>{{ $t('message.txtManagement.title1') }}</span>
            </a-breadcrumb-item>
            <a-breadcrumb-item href="">
              <a-icon type="book" />
              <span>{{ $t("message.blackAndWhiteList.blackAndWhiteList") }}</span>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </template>
      </a-page-header>
      <div class="page-title mb20">{{ $t("message.blackAndWhiteList.blackAndWhiteListManagement") }}</div>
      <a-card class="mb16">
        <a-row :gutter="32">
          <a-col class="gutter-row" :span="7">
            <a-input :size="$globalSize" v-model="filterForm.unSubscribeValue"
              :placeholder="$t('message.strategyManagement.strategyLabel2')">
              <div slot="addonBefore">
                {{ $t("message.memberCenter.phone") + ' / ' + $t("message.memberCenter.email") }}:
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="7">
            {{ $t("message.strategyManagement.BWMTableCol2") }}：
            <a-select :size="$globalSize" style="width: 68%" :placeholder="$t('message.strategyManagement.BWMTableCol2')"
              v-model="filterForm.valueType" allowClear>
              <a-select-option key="phone">
                {{ $t("message.memberCenter.phoneNumber") }}
              </a-select-option>
              <a-select-option key="email">
                {{ $t("message.memberCenter.email") }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col class="gutter-row" :span="10">
            <a-button class="my-btn" :size="$globalSize" style="float: right;" type="primary"
              :disabled="strategyListLoading" @click="onSearch">{{ $t("message.commonUsage.search") }}</a-button>
          </a-col>
        </a-row>
      </a-card>
     
      <div class="flex justify-content-end grid-gap-16">
        <a-button :size="$globalSize" type="primary" class="flex align-items-center justify-content-center grid-gap-12 my-btn"
          style="min-width: 120px;" @click="whichOne = 'add'">
          {{ $t("message.blackAndWhiteList.addList") }}
        </a-button>
        <a-button :size="$globalSize" class="flex align-items-center justify-content-center grid-gap-12 my-btn"
          style="min-width: 120px;" @click="whichOne = 'import'">
          {{ $t("message.blackAndWhiteList.importList") }}
        </a-button>
        <!-- <a-button  :size="$globalSize" 
            
            class="flex align-items-center justify-content-center grid-gap-12"
            @click="exportFile"
            :loading="downloadLoading"
            style="min-width: 120px;background: rgba(246 , 245, 217, 1);color: rgba(0, 0, 0, 0.6);"

        >
          {{ $t("message.commonUsage.export") }}
        </a-button> -->
      </div>
      <a-card class="content mt16">
        <a-spin :spinning="spinning">
          <a-table id="userListTable" :columns="columns" :data-source="integralRuleList" row-key="id"
            :pagination="false">
            <template slot="startAndEndDate" slot-scope="text,record">
              {{ formatDate(record.effective_date) + ' - ' + formatDate(record.expiring_date) }}
            </template>

            <template slot="op" slot-scope="text, record">
              <div class="flex justify-content-center align-items-center grid-gap-16 w100 h100">
                <!--详情-->
                <span v-if="record.state === 2"
                  class="flex justify-content-center align-items-center grid-gap-4 cursor-pointer"
                  @click="viewDetail(record)">
                  <span
                    style="display:inline-block;width: 24px;height: 24px;line-height:24px;background:rgba(31, 106, 247, 0.2);font-size: 18px;">
                    <a-icon type="info" style="color: #1F6AF7;" />
                  </span>
                  <span class="operate-icon-text">{{ $t('message.commonUsage.detail') }}</span>
                </span>


                <!--删除-->
                <a-button type="primary" shape="circle" class="delete-btn-icon" @click="del(record)" />
              </div>
            </template>
          </a-table>
          <div style="padding: 20px 0">
            <my-pagination ref="myPaginationRef" :total="totalCount" @change="getBlackWhiteList"></my-pagination>
          </div>
        </a-spin>
      </a-card>
    </div>
    <add-list v-if="whichOne === 'add' || whichOne === 'edit' || whichOne === 'view'" :page-type="whichOne"
      :curItem="currentItem" @close="whichOne = 'home'" />
    <import-list v-if="whichOne === 'import'" :page-type="whichOne" :curItem="currentItem" @close="whichOne = 'home'" />
    <base-config ref="baseConfigRef" v-if="whichOne === 'config'" @close="whichOne = 'home'" />
    <order-limit ref="orderLimitRef" v-if="whichOne === 'limit'" @close="whichOne = 'home'" />
    <a-modal :title="getTitle" :visible="visible" @cancel="handleCancel" :footer="null" centered
      :bodyStyle="{ 'padding-left': '24px' }">
      <div class="confirm-modal-body w100 flex justify-content-center align-items-center">
        {{ getContent() }}
      </div>
      <div class="w100 flex justify-content-center grid-gap-16 mt24">
        <a-button :size="$globalSize" class="form-submit-btn" @click="opClick" :loading="confirmLoading">{{
          $t('message.commonUsage.confirm')
          }}
        </a-button>
        <a-button :size="$globalSize" class="form-cancel-btn" @click="handleCancel">{{
          $t('message.commonUsage.cancel')
          }}
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import MyPagination from "@/components/MyPagination";
import addList from "@/views/application/ai/blackAndWhiteList/addList";
import importList from "@/views/application/ai/blackAndWhiteList/importList";
import baseConfig from "@/views/integralRule/baseConfig";
import orderLimit from "@/views/integralRule/orderLimit";
import { formatDate } from "@/utils/formatUtils";
import { pointsRulesIcon, deleteIcon } from "@/components/richIcon/index"
import blackWhiteService from "@/interface/pages/blackWhiteList";
import { saveFile } from "@/utils/common";

export default {
  name: "blackAndWhiteList",
  components: {
    MyPagination,
    pointsRulesIcon,
    addList,
    importList,
    baseConfig,
    orderLimit,
    deleteIcon
  },
  mounted() {
    utils.languageChange(this, {labelCol: 4, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
  },
  data() {
    let checkValType = (rule, value, callback) => {
      if (this.filterForm.unSubscribeValue && !value) {
        callback(new Error(this.$t("message.pushStrategy.pleaseSelect")));
      } else {
        callback()
      }
    };
    return {
      whichOne: 'home',
      confirmLoading: false,
      downloadLoading: false,
      visible: false,
      
      columns: [
        {
          title: () => this.$t("message.commonUsage.serialNumber"),
          dataIndex: "id",
          key: "id",
          width: 80,
          ellipsis: true,
        },
        {
          title: () => this.$t("message.memberCenter.phone") + ' / ' + this.$t("message.memberCenter.email"),
          width: 200,
          ellipsis: true,
          dataIndex: "unsubscribe_value",
          key: "unsubscribe_value",
        },
        {
          title: () => this.$t("message.memberCenter.startAndEndDate"),
          align: "left",
          width: 200,
          ellipsis: true,
          scopedSlots: {
            customRender: 'startAndEndDate'
          }

        },
        {
          title: () => this.$t("message.commonUsage.operation"),
          align: "center",
          dataIndex: "op",
          width: 200,
          key: "op",
          ellipsis: true,
          scopedSlots: { customRender: "op" }, //格式化，需要注意的是a-table中插槽的绑定
        },
      ],
      totalCount: 0,
      filterForm: {
      },
      spinning: false,
      integralRuleList: [],
      rules: {
        valueType: [
          {
            validator: checkValType,
            trigger: 'change',
          },
        ],
      },
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 6
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 16 : 16
      },
      groupList: [],
      statusList: [
        {
          label: '无效',
          value: 0
        }, {
          label: '有效',
          value: 1
        }
      ],
      currentItem: null,
      curOp: ''
    };
  },
  methods: {
    formatDate,
    exportFile() {
      this.downloadLoading = true
      blackWhiteService.exportList(this, { data: this.integralRuleList }).then(res => {
        saveFile(res, "查询结果.xlsx")
      }).catch((err) => {
        this.$message.error(err);
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    getTitle() {
      switch (this.curOp) {
        case 'delete':
          return this.$t('message.memberCenter.deleteRuleConfirmTitle')
        default:
          return this.$t('message.commonUsage.tip')
      }
    },
    getContent() {
      switch (this.curOp) {
        case 'delete':
          return this.$t('message.blackAndWhiteList.confirmTip')
        default:
          return this.$t('message.commonUsage.addConfirmContent')
      }
    },
    async opClick(resolve, reject) {
      this.confirmLoading = true
      let response
      let tip = this.$t('message.commonUsage.successfullySaved')
      switch (this.curOp) {
        case 'delete':
          response = await blackWhiteService.deleteBlackWhiteList(this, {
            data: {
              id: this.currentItem.id,
              userId: localStorage.getItem('userId'),
            }
          });
          tip = this.$t('message.commonUsage.deleteSuccess')
          break;
      }
      if (response.data.code == 200) {
        this.$message.success(tip);
        this.visible = false
        this.getBlackWhiteList()
        resolve()
      } else {
        this.$message.error(response.data.msg);
        reject()
      }
      this.confirmLoading = false
    },
    handleCancel() {
      this.visible = false
    },

    viewDetail(record) {
      this.curOp = 'view'
      this.currentItem = record
      this.whichOne = 'view'
    },
    toEdit(record) {
      this.currentItem = record
      this.whichOne = 'edit'
      this.curOp = 'edit'
    },
    del(record) {
      this.currentItem = record
      this.curOp = 'delete'
      let _self = this
      this.$confirm({
        title: this.getTitle(),
        okText: this.$t('message.commonUsage.confirm'),
        cancelText: this.$t('message.commonUsage.cancel'),
        onOk() {
          return new Promise((resolve, reject) => {
            _self.opClick(resolve, reject)
          })
        },
        onCancel() {
          _self.handleCancel()
        }
      });
    },

    search() {
      this.$refs.filterFormRef.validate(valid => {
        if (!valid) return false;
        this.getBlackWhiteList()
      });
    },
    reset() {
      this.$refs.filterFormRef.resetFields();
      this.$refs.myPaginationRef.initCurrent()
    },
    async getBlackWhiteList() {
      this.spinning = true;
      const { data: res } = await blackWhiteService.getBlackWhiteList(this, {
        params: {
          ...this.filterForm,
          ...this.$refs.myPaginationRef.pagination
        }
      });
      if (res.code == 200) {
        this.integralRuleList = res.data;
        this.totalCount = res.totalCount;
      } else {
        if (res.code !== '400') {
          this.$message.error(res.msg);
        }
      }
      this.spinning = false;
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .ant-table-placeholder {
  height: 500px;
}

#userListTable .ant-btn {
  padding: 0 0 0 10px;
}

.group-table ::v-deep .ant-table-tbody tr {
  height: 90px !important;
}

::v-deep .ant-form-item-label {
  display: inline-block;
  //width: 60px;
  text-align: right;
  font-family: PingFang SC;
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: 0em;
}

::v-deep .ant-form label {
  font-size: 14px;
}

::v-deep .ant-input-lg,
::v-deep .ant-select-lg {
  font-size: 14px;
}

/* 表格斑马样式 **/
::v-deep .ant-table-tbody tr:nth-child(2n-1) {
  background: rgba(239, 140, 58, 0.05);
}

.module-title {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);

}

.rules-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);

}

.rules-desc {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.9);

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #FD6434;
    margin-right: 8px;
  }
}

.operate-icon-text {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0em;
  color: rgba(0, 0, 0, 0.6);

}

::v-deep .ant-form-item-label{
  text-align: left !important;
}

::v-deep .ant-input-group-addon{
  background-color: #fff;
  border:none
}
</style>
